require(['jquery', 'js/glider-min'], function ($) {
const heroSliders = document.querySelectorAll(".js-product-line-wall-slider");
	const prevButton = document.querySelector('.js-product-line-wall-slider-prev');
	const nextButton = document.querySelector('.js-product-line-wall-slider-next');

if (heroSliders) {
	heroSliders.forEach(heroSlider => {
		const sliderDataId = heroSlider.getAttribute('data-uid');
		const glider = new Glider(heroSlider, {
			slidesToShow: 1.1,
			slidesToScroll: 1,
			draggable: true,
			scrollLock: true,
			rewind: true,
			arrows: {
				prev: ".js-product-line-wall-slider-prev.slider-id-"+sliderDataId,
				next: ".js-product-line-wall-slider-next.slider-id-"+sliderDataId
			},
			dots: '.js-product-line-wall-slider-bullets'
		});

		glider.isLastSlide = function() {
			return slider.page >= slider.dots.childElementCount - 1;
		}

		let hovering = false;
		let isFocused = false;

		let animID = 0;
		const isAnimating = () => glider.animate_id !== animID;
		const prevButton = heroSlider.closest('.c-product-line-wall-slider').querySelector('.js-product-line-wall-slider-prev');
		const nextButton = heroSlider.closest('.c-product-line-wall-slider').querySelector('.js-product-line-wall-slider-next');


		heroSlider.addEventListener('mouseover', (event) => {
			hovering = true;
		});

		nextButton.addEventListener('focusin', (event) => {
			isFocused = true;
		});

		nextButton.addEventListener('focusout', (event) => {
			isFocused = false;
		});

		prevButton.addEventListener('focusin', (event) => {
			isFocused = true;
		});

		prevButton.addEventListener('focusout', (event) => {
			isFocused = false;
		});

		heroSlider.addEventListener('focusin', (event) => {
			isFocused = true;
		});

		heroSlider.addEventListener('focusout', (event) => {
			isFocused = false;
		});

		heroSlider.addEventListener("glider-animated", function (event) {
			animID = glider.animate_id;
			if (!hovering && !isFocused) {
			}
		});
	})
}
	window.addEventListener('load', (event) => {
		function hideArrowsAndBulletsIfSingleItem() {
			if (!heroSliders) {
				return;
			}
			const heroSliderItems = document.querySelectorAll('.c-product-line-wall-slider__item');
			const arrowsElements = document.querySelectorAll('.c-product-line-wall-slider__arrows');
			const bulletsElement = document.querySelector('.c-product-line-wall-slider__bullets');

			if (heroSliderItems.length === 1) {
				arrowsElements.forEach(element => {
					element.style.display = 'none';
				});

				if (bulletsElement) {
					bulletsElement.style.display = 'none';
				}
			}
		}
		hideArrowsAndBulletsIfSingleItem();
	})

});

